module.exports = __webpack_public_path__ + "media/images/front/about/thumbnail_top-f438498e39634b390ae73fb61aba04fd.jpg";